import { default as LogoCRM } from '@/assets/logos/miliboo-crm-min.svg?react';
import { default as LogoDP } from '@/assets/logos/miliboo-dp-min.svg?react';
import { default as LogoPIM } from '@/assets/logos/miliboo-pim-min.svg?react';
import { default as LogoSAV } from '@/assets/logos/miliboo-sav-min.svg?react';
import { default as LogoTMS } from '@/assets/logos/miliboo-tms-min.svg?react';
import { pomConfig } from '@/configs/pom-config';

const { externalApps } = pomConfig;

export const sidebarProjectsConfig = [
  {
    name: 'TMS',
    logo: (
      <LogoTMS
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Transport',
    link: externalApps.tms,
  },
  {
    name: 'PIM',
    logo: (
      <LogoPIM
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Product',
    link: externalApps.pim,
  },
  {
    name: 'CRM',
    logo: (
      <LogoCRM
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Commercial',
    link: externalApps.crm,
  },
  {
    name: 'SAV',
    logo: (
      <LogoSAV
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'Aftersales',
    link: externalApps.sav,
  },
  {
    name: 'Demand Planning',
    logo: (
      <LogoDP
        className='rounded-md text-white'
        style={{ width: '48px', height: '48px' }}
      />
    ),
    plan: 'DemandPlanning',
    link: externalApps.demandPlanning,
  },
];
